// extracted by mini-css-extract-plugin
export default {"modal":"view-replies-modal_modal__F6FAf","content":"view-replies-modal_content__zyN3R"};